import * as React from 'react';
import { ComponentProps } from '../DataTable';

export interface ActiveFilterProps extends ComponentProps {
    /**
     * Function to invoke when the the checkbox is clicked
     */
    onChange: (checked: boolean) => void;
    /**
     * Whether the checkbox is clicked
     * (The state resides in the DataTable component)
     */
    showActiveOnly: boolean;
}

/**
 * The component represents the show active only checkbox
 * @param props Component props
 */
export function ActiveFilter(props: ActiveFilterProps) {
    const id = 'showActive_' + props.idSuffix;

    return (
        <div className="form-group">
            <label className="form-label clickable" htmlFor={id}>
                Show active only
            </label>
            <input
                type="checkbox"
                checked={props.showActiveOnly}
                onChange={event => props.onChange(event.target.checked)}
                id={id}
            />
        </div>
    );
}
